<template>
  <a-config-provider :locale="zhCN">
    <router-view />
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'

export default {
  name: 'App',
  data() {
    return {
      zhCN
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  overflow-y: hidden;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  overflow-y: auto;
  height: 100vh;
}

#app {
  height: 100vh;
}

/* 全局选中文本样式 - 更深的背景色 */
::selection {
  background-color: #1890ff;
  color: #fff;
}

::-moz-selection {
  background-color: #1890ff;
  color: #fff;
}
</style>
